<template>
  <!-- 已打包退换货直接完成弹框 -->
  <el-dialog :title="$t('message.completeDirectly')" :visible.sync="visible" width="600px"
    :close-on-click-modal="false" :close-on-press-escape="!busy" :show-close="!busy" @closed="reset">
    <el-form label-width="70px">
      <el-form-item :label="$t('message.directCompleteDescription')">
        <el-input v-model="form.remark" type="textarea" :rows="5"
          :placeholder="$t('message.directCompleteDescriptionPlaceholder')" />
      </el-form-item>
      <el-form-item :label="$t('message.directCompleteProof')">
        <el-upload action="#" multiple :limit="8" :file-list="files" :http-request="uploadProof"
          :on-success="handleProofSuccess" :on-error="handleProofError" :on-remove="handleProofRemove"
          :on-exceed="handleProofExceed" :disabled="busy">
          <el-button size="small" type="primary" :loading="uploadCount > 0">
            {{ $t("message.uploadProof") }}
          </el-button>
          <div slot="tip" class="el-upload__tip">{{ $t("message.directCompleteRequirement") }}</div>
        </el-upload>
      </el-form-item>
    </el-form>
    <template slot="footer" class="dialog-footer">
      <el-button :disabled="busy" @click="visible = false">
        {{ $t("message.cancel") }}
      </el-button>
      <el-button type="primary" :loading="submitting" :disabled="uploadCount > 0" @click="submit">
        {{ $t("message.submit") }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      form: {
        refund_sn: "",
        remark: "",
        proof: [],
      },
      files: [],
      uploadCount: 0,
      submitting: false,
    };
  },
  computed: {
    busy() {
      return this.uploadCount > 0 || this.submitting;
    },
  },
  methods: {
    // 父列表通过退换货单号打开弹框
    open(refund_sn) {
      this.reset();
      this.form.refund_sn = refund_sn;
      this.visible = true;
    },
    reset() {
      this.form = {
        refund_sn: "",
        remark: "",
        proof: [],
      };
      this.files = [];
      this.uploadCount = 0;
    },
    // 复用项目 createClient，将原文件上传至 OSS 并返回远端 URL
    async uploadProof(file) {
      this.uploadCount += 1;
      try {
        const res = await this.createClient(file);
        return res.data;
      } finally {
        this.uploadCount -= 1;
      }
    },
    handleProofSuccess(url, file, fileList) {
      file.url = url;
      this.syncProof(fileList);
    },
    handleProofError(error, file, fileList) {
      this.syncProof(fileList.filter(item => item.uid !== file.uid));
      this.$message.error(this.$t("message.proofUploadFailed"));
    },
    handleProofRemove(file, fileList) {
      this.syncProof(fileList);
    },
    handleProofExceed() {
      this.$message.error(this.$t("message.directCompleteProofLimit"));
    },
    // 接口仅接收远端 URL，文件列表变化后同步 proof 数组
    syncProof(fileList) {
      this.files = fileList;
      this.form.proof = fileList.map(item => item.url).filter(Boolean);
    },
    // 说明与凭证二选一，完成后通知父列表刷新
    async submit() {
      const remark = this.form.remark.trim();
      if (!remark && this.form.proof.length === 0) {
        return this.$message.error(this.$t("message.directCompleteRequired"));
      }

      this.submitting = true;
      try {
        const res = await this.$api.signInApi.refundDirectComplete({
          refund_sn: this.form.refund_sn,
          remark,
          proof: this.form.proof,
        });
        this.$message.success(res.msg);
        this.visible = false;
        this.$emit("success");
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>
